// 개인정보 처리방침 v3.3.5 — 공고 2026-10-27 · 시행 2026-11-03 (계획 docs/계획_가입위주_외주업체등록_S5_2026-10-27.md Q6, 대표 10-27 "권고대로")
//   문안 정본: docs/법무검토_가입위주_외주업체등록_S5_2026-10-27.md §2-5 (법적보안 1차 필터 — 최종은 변호사). 아래 ★ 상수는 그 문서 글자 그대로 — 한 글자라도 바꾸면 법적보안 재확인.
//   ☆ 표식 상수(개정 공고 상자의 제목·이유·주요 내용·한 줄)는 v3.2.8 전례(config/privacyV328.js §2-4) 틀에 날짜·판만 넣은 자체 문구 — 법적보안 확인 대상.
//   사용처: PrivacyPolicy.js(개정 공고 상자·본문 전환·버전·이력), Register.js(가입 화면 번호 입력 칸·외주 선택 블록·서약 체크의 날짜 게이트 — 시행 전에는 그리지도 저장하지도 않음, 법무 §2-2 [상]).
//   ⚠️ 시행일을 바꾸면 Register.js 게이트도 같이 바뀐다(상수 한 곳). 공고일에 배포하지 못하면 공고 D → 시행 D+7 로 둘 다 옮기고 법적보안에 알린다.
//   로그인 띠(MainLayout 로그인 후 띠·Login 접힌 한 줄)는 v3.2.8 전례(privacyV328.js §3-1·§3-2) 그대로 — 최종마스터 추가 지시(10-27, 대표 "바로 공지로 진행").

export const PRIVACY_V335_VERSION = 'v3.3.5';
export const PRIVACY_V335_NOTICE_DATE = '2026년 10월 27일';
export const PRIVACY_V335_DATE = '2026년 11월 3일';
export const PRIVACY_V335_NOTICE_MS = Date.parse('2026-10-27T00:00:00+09:00');
export const PRIVACY_V335_EFFECTIVE_MS = Date.parse('2026-11-03T00:00:00+09:00');
// 띠 게시 끝: v3.2.8 전례(시행일 + 7일 00:00 KST, 시행 전에는 시각으로 내려가지 않음) → 2026-11-10 00:00 KST
export const PRIVACY_V335_BANNER_END_MS = Date.parse('2026-11-10T00:00:00+09:00');

/** 시행 판정 — 2026-11-03 00:00 KST 부터. Register.js 의 번호 입력 칸·외주 선택·서약 체크 게이트와 PrivacyPolicy.js 본문 전환이 같은 함수를 쓴다 */
export const isPrivacyV335On = (now = Date.now()) => now >= PRIVACY_V335_EFFECTIVE_MS;
/** 개정 공고 상자 노출: 공고일 00:00 KST 이후 항상(시행 뒤에는 "시행 중" 한 줄로 바뀜 — v3.2.8 전례) */
export const isPrivacyV335Announced = (now = Date.now()) => now >= PRIVACY_V335_NOTICE_MS;
/** 띠 게시 기간: 공고일 00:00 ~ 게시 끝 전 (MainLayout·Login — v3.2.8 isPrivacyV328BannerPeriod 와 같은 규칙) */
export const isPrivacyV335BannerPeriod = (now = Date.now()) => now >= PRIVACY_V335_NOTICE_MS && now < PRIVACY_V335_BANNER_END_MS;

// ── ☆ 로그인 후 띠 / 로그인 화면 접힌 한 줄 (v3.2.8 §3-1·§3-2 틀 — 법적보안 확인 대상. 닫기 키 v3.3.5 전용 — 다른 판 키 재사용 금지) ──
export const V335_BANNER_TEXT = '개인정보처리방침이 바뀝니다(10월 27일 공고 · 11월 3일 시행). 회원 가입 때 치과기공소 회원의 소속 치과기공사 성명·면허번호(선택)와 개설등록번호, 제조업체 회원의 의료기기 제조업 허가번호를 받는 수집 항목과 회원 자격·외주 수주 자격 확인 목적, 번호 파기 시점이 추가됩니다. ';
export const V335_BANNER_LINK = '전문 보기 →';
export const V335_LOGIN_TITLE = `개인정보처리방침 개정 안내 (${PRIVACY_V335_VERSION} · 2026-11-03 시행) `;
export const V335_DISMISS_KEY_PREFIX = 'policyBannerV335Dismissed_';   // + uid / 'login'

// ── ★ 법무 §2-5 문안 (글자 그대로) ──
// 섹션 2 「가. 수집하는 개인정보 항목」 — 업체 회원(치과/기공소) 행 뒤에 추가하는 문장
export const V335_LAB_MEMBER_ADD = '치과기공소 회원: 치과기공소 개설등록번호(외주 제작 수주를 선택한 경우), 소속 치과기공사 1명의 성명·치과기공사 면허번호(선택 입력 — 가입자 본인이 아닐 수 있음)';
// 섹션 2 표 신설 행 「제조업체 회원」 [행 제목, 항목]
export const V335_MFR_ROW = Object.freeze(['제조업체 회원', '업체명, 사업자등록번호, 주소, 대표자명, 의료기기 제조업 허가번호 또는 치과기공소 개설등록번호, 프리밀드 블랭크 사용 여부, 제작 분야']);
// 섹션 2 「나. 수집 방법」 추가 항목
export const V335_COLLECT_METHOD_LINE = '회원 가입 화면 및 설정 › 외주 수주 설정 화면에서 회원이 직접 입력';
// 섹션 1 「나. 회원 관리」 추가 항목 2개
export const V335_PURPOSE_ITEMS = Object.freeze([
    '치과기공소·제조업체 회원의 자격(치과기공소 개설등록, 치과기공사 소속, 의료기기 제조업 허가) 확인 및 외주 제작·외주 제조 수주 자격 확인 — 회사는 제출된 번호를 식품의약품안전처 등 관계 기관의 공개 자료로 확인하며, 치과기공사 면허의 진위는 공개 조회 수단이 없어 확인하지 않습니다',
    '명의 대여·부정 가입 방지',
]);
// 섹션 3 보유기간 추가 문장 (심사 기록 3년 — 법무 제안값을 계획에서 채택. 정본의 「[○ 3년은 분쟁 대비 제안값 — 대표 지정]」 표식은 편집 메모라 문안에서 뺐다)
export const V335_RETENTION_LINE = '치과기공사 면허번호·성명, 치과기공소 개설등록번호, 의료기기 제조업 허가번호는 회원 탈퇴 시 또는 회원이 외주 수주 종료를 요청한 때 지체 없이 파기합니다. 승인 심사 기록(심사 일시·결과·확인자)은 번호를 제외하고 회원 탈퇴 후 3년까지 보관합니다.';
// 열람 범위·안전조치 1문장 (섹션 7 끝에 그린다)
export const V335_ACCESS_LINE = '면허번호·허가번호는 입력한 회원 본인과 회사 관리자만 열람할 수 있으며, 다른 회원에게 공개되는 업체 소개에는 포함하지 않습니다. 관리자가 열람·확인한 기록을 남깁니다.';
// 변경 이력 줄 본문(판·날짜는 PrivacyPolicy.js 가 앞에 붙인다)
export const V335_HISTORY_BODY = '2. 수집 항목에 치과기공소 회원의 개설등록번호·소속 치과기공사 성명·면허번호(선택), 제조업체 회원 행 추가, 1. 목적에 회원 자격·외주 수주 자격 확인 추가, 3. 보유 기간에 번호 파기 시점(탈퇴 또는 외주 수주 종료 요청 시) 추가';
// 버전 상자 한 줄 설명
export const V335_VERSION_DESC = '치과기공소 회원 개설등록번호·소속 치과기공사 성명·면허번호(선택), 제조업체 회원 수집 항목, 회원 자격·외주 수주 자격 확인 목적, 번호 파기 시점 추가';   // ☆

// ── ☆ 「개정 공고」 상자 (v3.2.8 전례 틀 — 법적보안 확인 대상) ──
export const V335_NOTICE_LINE_BEFORE = `개인정보 처리방침 ${PRIVACY_V335_VERSION} 개정을 ${PRIVACY_V335_NOTICE_DATE}에 공고했습니다. 시행일 ${PRIVACY_V335_DATE}까지는 현행 방침이 적용됩니다.`;
export const V335_NOTICE_LINE_AFTER = `개인정보 처리방침 ${PRIVACY_V335_VERSION}이 ${PRIVACY_V335_DATE}부터 시행 중입니다(${PRIVACY_V335_NOTICE_DATE} 공고).`;
export const V335_NOTICE = Object.freeze({
    title: `개인정보 처리방침 개정 공고 (${PRIVACY_V335_VERSION})`,
    dates: `공고일: ${PRIVACY_V335_NOTICE_DATE} · 시행일: ${PRIVACY_V335_DATE}`,
    reason: '회원 가입 때 치과기공소 회원의 소속 치과기공사 성명·면허번호(선택)와 개설등록번호(외주 제작 수주를 선택한 경우), 제조업체 회원의 의료기기 제조업 허가번호를 받아 회원 자격과 외주 수주 자격을 확인하는 절차를 추가하기 위해 개정합니다.',
    mains: [
        '1. 수집 항목(「2. 수집하는 개인정보의 항목 및 수집 방법」): 치과기공소 회원의 개설등록번호(외주 제작 수주를 선택한 경우)와 소속 치과기공사 1명의 성명·면허번호(선택 입력), 제조업체 회원 행 추가, 수집 방법에 가입 화면·설정 › 외주 수주 설정 화면 직접 입력 추가.',
        '2. 처리 목적(「1. 개인정보의 수집 및 이용 목적」 나. 회원 관리): 회원 자격·외주 수주 자격 확인(번호는 관계 기관 공개 자료로 확인, 치과기공사 면허의 진위는 확인하지 않음), 명의 대여·부정 가입 방지 추가.',
        '3. 보유 기간(「3. 개인정보의 보유 및 이용 기간」): 면허번호·성명·개설등록번호·제조업 허가번호는 회원 탈퇴 시 또는 외주 수주 종료 요청 시 파기, 승인 심사 기록(번호 제외)은 탈퇴 후 3년 보관.',
        '4. 열람 범위(「7. 정보주체의 권리·의무 및 행사 방법」): 면허번호·허가번호는 본인과 회사 관리자만 열람, 업체 소개에 포함하지 않음, 관리자 열람·확인 기록 보관.',
    ],
    contact: '문의: 개인정보 보호책임자 010-2972-3733 · dentcluster@gmail.com',
});
